export default "__VITE_ASSET__Dzc$wkIl__"